<!-- Catalog Window -->
<ng-container *ngFor="let row of leftWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <g mask="url(#mask0)">
                <g mask="url(#mask1)">
                    <mask
                        [attr.id]="'mask' + i + '_' + j"
                        style="mask-type: luminance"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        [attr.width]="windowWidth"
                        [attr.height]="windowHeight">
                        <path
                            d="M29.7619 31.2193L0.479004 13.9322V0.357422L29.7619 17.6378V31.2193Z"
                            fill="white" />
                    </mask>
                    <g [attr.mask]="'url(#mask' + i + '_' + j + ')'">
                        <path
                            class="window-left"
                            [style.animationDelay]="i * j * 0.01 + 's'"
                            d="M29.7489 -0.243164L-0.112305 0.368472L0.489902 31.8196L30.3511 31.2079L29.7489 -0.243164Z"
                            [attr.fill]="isWindowLit(i, j, true) ? 'var(--window-lit-bg-1)' : 'var(--window-dark-bg-1)'" />
                    </g>
                </g>
            </g>
        </svg:g>
    </ng-container>
</ng-container>

<ng-container *ngFor="let row of rightWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <g mask="url(#mask0)">
                <g mask="url(#mask1)">
                    <mask
                        [attr.id]="'right_mask' + i + '_' + j"
                        style="mask-type: luminance"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        [attr.width]="windowWidth"
                        [attr.height]="windowHeight">
                        <path
                            d="M0.576233 32.1193L29.8504 14.9868V1.38965L0.576233 18.5379V32.1193Z"
                            fill="white" />
                    </mask>
                    <g [attr.mask]="'url(#right_mask' + i + '_' + j + ')'">
                        <path
                            class="window-left"
                            [style.animationDelay]="i * j * 0.01 + 's'"
                            d="M29.8027 0.161621L-0.626038 1.43866L0.623867 33.3446L31.0548 32.0698L29.8027 0.161621Z"
                            [attr.fill]="isWindowLit(i, j, false) ? 'var(--window-lit-bg-2)' : 'var(--window-dark-bg-2)'" />
                    </g>
                </g>
            </g>
        </svg:g>
    </ng-container>
</ng-container>
